import { TextField } from '@mui/material';

const DefaultTextInputField = ({ currentFilter, setCurrentFilter }) => (
	<TextField
		sx={{ fontSize: '14px' }}
		value={currentFilter.value ?? ''}
		onChange={(e) => {
			setCurrentFilter({ ...currentFilter, value: e.target.value });
		}}
		label="Value"
		variant="standard"
	/>
);

export default DefaultTextInputField;
